angular.module("vgresiduos").controller("ContentNavBarCtrl", [
	"$scope",
	"$state",
	"$stateParams",
	"$rootScope",
	function ($scope, $state, $stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			getTitle();

			$scope.labels = $rootScope.labels;
		};

		this.$onDestroy = function () {
			// nullify the DOM-bound model
			$scope.domElement = null;
		};

		function getTitle() {
			$scope.title = $scope.ctrl.contentNavBarOptions ? $scope.ctrl.contentNavBarOptions.title : null;
		}

		$scope.getCurrentId = function () {
			if ($scope.ctrl.contentNavBarOptions.breadcrumb) {
				return $scope.ctrl.contentNavBarOptions.breadcrumb;
			} else if ($stateParams.id) {
				return $stateParams.id;
			} else {
				return $rootScope.labels.NEW;
			}
		};

		$scope.goBackToPreviousPage = function () {
			if ($scope.ctrl.contentNavBarOptions.returnState) {
				$state.go($scope.ctrl.contentNavBarOptions.returnState);
				$scope.ctrl.contentNavBarOptions.returnState = false;
			} else if ($scope.ctrl.contentNavBarOptions.back) {
				$scope.useBack($scope.ctrl.contentNavBarOptions.back);
			}
		};

		$scope.useBack = function (back) {
			if (back.constructor.name === "AsyncFunction") {
				back().then(function () {
					$scope.ctrl.contentNavBarOptions.back = false;
				});
			} else if (typeof back === "function") {
				back();
				$scope.ctrl.contentNavBarOptions.back = false;
			} else if (typeof back === "string") {
				$state.go(back);
				$scope.ctrl.contentNavBarOptions.back = false;
			}
		};
	}
]);
